var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      directives: [{ name: "tooltip", rawName: "v-tooltip" }],
      ref: "addToWishList",
      staticClass: "btn btn-link btn-sm text-muted color-gray-700",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: _vm.tooltipText
      },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.switchState()
        }
      }
    },
    [
      _c("icon", {
        staticClass: "default-float",
        class: { "text-appearance text-danger": _vm.isVariationInWishList },
        attrs: {
          icon: _vm.isVariationInWishList ? "heart" : "heart-o",
          loading: _vm.isLoading
        }
      }),
      _vm._v("\n  " + _vm._s(_vm.wishListButtonText) + "\n  "),
      _vm.isVariationInWishList
        ? _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("✓")])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }